// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plugin-icon[data-v-24367e4a]{width:16px;height:16px;border-radius:2px}", ""]);
// Exports
module.exports = exports;
